import RevolverModel from "slotworks/integration/revolver/model/revolver-model";
import { ResultsAndDetail } from "slotworks/integration/revolver/schema/spin-record-schema";
import Result from "slotworks/model/gameplay/records/results/result";
import ScatterResult from "slotworks/model/gameplay/records/results/scatter-result";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { ResultBuilder } from "slotworks/server/builders/result-builder";
import SymbolModel from "slotworks/server/symbols/symbol-model";

class ScatterResultBuilder implements ResultBuilder {

    public filter(data: any): boolean {
        const resultsAndDetail = data as ResultsAndDetail;

        if (!resultsAndDetail) {
            return false;
        }

        const detail = resultsAndDetail.detail;

        return detail && detail.type && detail.type === "$SCATTER";
    }

    public build(record: SpinRecord, data: any): Result[] {
        const resultsAndDetail = data as ResultsAndDetail;
        const detail = resultsAndDetail.detail;

        const result = new ScatterResult();
        result.creditsWon = detail.cash;
        result.matches = detail.positions.length;
        result.symbolType = SymbolModel.convertSymbolToSlotworks(detail.symbol);

        if (RevolverModel.isFreespin(detail.feature)) {
            result.freespinsWon = resultsAndDetail.results.eval.freeSpinsCount;
        }

        result.positions = RevolverModel.convertPositionsToGridPositions(detail.positions);

        return [result];
    }
}

export default new ScatterResultBuilder();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/builders/results/scatter-result-builder.ts